<template>
	<div>
		<table class="table">
			<tr><td>Username</td><td>@{{user.username}}</td></tr>
			<tr v-if="user.email"><td>Email</td><td>{{user.email}}</td></tr>
			<tr v-if="user.about"><td>About</td><td>{{user.about}}</td></tr>
			<tr><td>Joined at</td><td>{{ new Date(user.created) | moment("dddd, MMMM Do YYYY") }}</td></tr>
		</table>
	</div>
</template>

<script>
	export default {
		name: 'ProfileWidget',
		props: {
			user: Object,
		}
	}
</script>